// C3: shared touch-strategy markers for the Telegram touch channel.
//
// The API service composes them into task descriptions when a touch-strategy
// telegram step is executed; the tasks UI and the Telegram reminder tick read
// them back to recognize telegram-touch tasks deterministically. Tasks have no
// channel column (B3 decision: no schema migration for touch metadata), so the
// marker travels as a description line — the same pattern the draft notes use
// with `#touch-strategy-draft`.

/** Machine marker written into the description of a telegram touch task. */
export const TOUCH_STRATEGY_TG_TASK_MARKER = '#tg-touch';

/** True when the task description carries the telegram-touch marker. */
export function isTelegramTouchTask(description: string | null | undefined): boolean {
  return typeof description === 'string' && description.includes(TOUCH_STRATEGY_TG_TASK_MARKER);
}
